
// NATIVE 

import dayjs from "dayjs";
import { enviroments } from "../../enviroments/enviroments";
import { storageGetAssignedUserPermissions } from "./Storage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { types } from "../types/types";
import { storeSetParameter } from "../../store/parameters";
import { forEach, map } from "lodash";

// INSTALLED 

// CUSTOM 


export const getUrlBase = () => {
    return enviroments.URL_BASE;
}

export const setDateValid = (date:string) => {

    return dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
    
}


export const eachWordUpper = (sentence:string) => {

    const wordLower = sentenceToLower(sentence);

    

    const words = wordLower.split(" ");

    for (let i = 0; i < words.length; i++) {
        
        if (words[i][0]) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        
        
    }
    return words.join(" ");

}


export const sentenceToLower = ( sentence:string ) => {
   
     return sentence.toLocaleLowerCase();
}



//                                  nombre modulo    sub modulo       permission
export const hasPemissions = async( module:string, submodule: string, action: string, submoduleName = '' ) => {
//    aqui
    const permissions =  await storageGetAssignedUserPermissions();



    for (let index = 0; index < permissions.length; index++) {
        
     
         if ( permissions[index].permission_slug == module ) { 
              
            for (let i = 0; i < permissions[index].childrens.length; i++) {
                 
            
                  if ( permissions[index].childrens[i].slug == submodule ) {

                    // VARIFICA SI TIENE SUBMODULO BUSCA DENTRO DE LOS SUBMODULOS O ELSE 
                    if ( permissions[index].childrens[i].childrens && permissions[index].childrens[i].childrens.length > 0 ) {
                       
                         for (let e = 0; e < permissions[index].childrens[i].childrens.length; e++) {

                            
                              if ( permissions[index].childrens[i].childrens[e].slug == submoduleName ) {
                                 
                                if ( permissions[index].childrens[i].childrens[e].actions.includes(action) ) {
                                     return true;
                                }
                              }
                            
                            
                         } 

                    } else {
                        
                        if ( permissions[index].childrens[i].actions.includes(action) ) {
                             return true;
                        }
                    
                    }
                       
                       

                  }
                
              }
         }
        
    }

    return false;
}



                                      // key storage                   // id element
// export const updateStatusRowTblPaginate = async ( storage: string, elementID: string, status:any) => {
    
//     const element = await AsyncStorage.getItem( storage ) || '{}';


//     const elementObject = JSON.parse(element);

//     if ( Object.keys(elementObject).length > 0  ) {

//         if ( elementObject.data ) {
             
//              const parameters = elementObject.data.map( (element:any) => {

//                  if ( element.id == elementID ) {
//                       element.status = status;
//                  }

//                  return element;

//              });

//              elementObject.data = parameters;


//              await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(elementObject));

//              return {
//                  ok: true,
//                  data: elementObject
//              }
             
//         }


//         return {
//             ok: false,
//             data: []
//         }
        
        
         
//     }


// }





export const updateStatusTableAndUpdateRedux = async ( elementID: string, status: number, data:any) => {
    
   


    const elementObject = JSON.parse(JSON.stringify(data));

    if ( Object.keys(elementObject).length > 0  ) {

        if ( elementObject.data ) {
             
             const parameters = elementObject.data.map( (element:any) => {

                 if ( element.id == elementID ) {
                      element.status = status;
                 }

                 return element;

             });

             elementObject.data = parameters;


             return {
                 ok: true,
                 data: elementObject
             }
             
        }


        return {
            ok: false,
            data: []
        }
        
        
         
    }


}


export const updateStatusRowTblPaginateRedux = async ( data: string, elementID: string, status:any) => {
    

    const elementObject:any = JSON.parse(JSON.stringify(data));


    if ( Object.keys(data).length > 0  ) {

        if ( elementObject.data ) {
             
             const parameters = elementObject.data.map( (element:any) => {

                 if ( element.id == elementID ) {
                      element.status = status;
                 }

                 return element;

             });

             elementObject.data = parameters;


             if ( status == 0) {
                  elementObject.activosTotal   = elementObject.activosTotal - 1;
                  elementObject.inactivosTotal = elementObject.inactivosTotal + 1;
             }

             if ( status == 1) {
                elementObject.activosTotal   = elementObject.activosTotal + 1;
                elementObject.inactivosTotal = elementObject.inactivosTotal - 1;
             }


            //  await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(elementObject));

             return {
                 ok: true,
                 data: elementObject
             }
             
        }


        return {
            ok: false,
            data: []
        }
        
        
         
    }


}







/**
 * Checks and formats the permissions for a user based on a given permissions list.
 * 
 * @param {any} permissionsList - The list of permissions to check against.
 * @param {any} permisssionsUser - The user object containing the user's permissions.
 * @returns {Promise<any>} - A promise that resolves to the formatted permissions list with updated `isChecked` and `actions` properties.
 * 
 * @example
 * const permissionsList = [
 *   { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *   { permission_slug: 'modulo.configuracion', childrens: [{ slug: 'modulo.logacciones', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * ];
 * 
 * const permisssionsUser = {
 *   user: {
 *     permissions: [
 *       { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *     ]
 *   }
 * };
 * 
 * const formattedPermissions = await userHasPermissionFormated(permissionsList, permisssionsUser);
 * // Output:
 * // [
 * //   { permission_slug: 'modulo.thumano', isChecked: true, childrens: [{ slug: 'modulo.empleados', isChecked: true, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 * //   { permission_slug: 'modulo.configuracion', isChecked: false, childrens: [{ slug: 'modulo.logacciones', isChecked: false, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * // ]
 */
export const userHasPermissionFormated = async ( permissionsList:any, permisssionsUser:any ) => {
    

    
    const permissionObject:any = JSON.parse(JSON.stringify(permissionsList));
    const customerObject:any = JSON.parse(JSON.stringify(permisssionsUser.user.permissions));


    
  
    if ( permissionObject.length > 0 && customerObject.length > 0  ) {

       

        for (let index = 0; index < customerObject.length; index++) {
            

            for (let i = 0; i < permissionObject.length; i++) {
                 
                
                
                 if ( permissionObject[i].permission_slug == customerObject[index].permission_slug ) {

                      permissionObject[i].isChecked = true;

                      for (let indexChildresUser = 0; indexChildresUser < customerObject[index].childrens.length; indexChildresUser++) { 

                           for (let indexChildresPermissionCustomer = 0; indexChildresPermissionCustomer < permissionObject[i].childrens.length; indexChildresPermissionCustomer++) {
                             
                                if (!permissionObject[i].childrens[indexChildresPermissionCustomer].hasOwnProperty("actions")) {
                                    permissionObject[i].childrens[indexChildresPermissionCustomer].actions = [];
                                }

                                if ( permissionObject[i].childrens[indexChildresPermissionCustomer].slug == customerObject[index].childrens[indexChildresUser].slug ) {
                                     permissionObject[i].childrens[indexChildresPermissionCustomer].isChecked = true;
                                     permissionObject[i].childrens[indexChildresPermissionCustomer].actions   = customerObject[index].childrens[indexChildresUser].actions;
                                }
                            
                           }

                      } // end for childrens customerObject

                 }
                 
                
            } // end for i
            
        } // end for index
        return permissionObject;
         
    } 
    return permissionObject;


}





/**
 * Checks and formats the permissions for a user based on a given permissions list.
 * 
 * @param {any} permissionsList - The list of permissions to check against.
 * @param {any} permisssionsUser - The user object containing the user's permissions.
 * @returns {Promise<any>} - A promise that resolves to the formatted permissions list with updated `isChecked` and `actions` properties.
 * 
 * @example
 * const permissionsList = [
 *   { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *   { permission_slug: 'modulo.configuracion', childrens: [{ slug: 'modulo.logacciones', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * ];
 * 
 * const permisssionsUser = {
 *   user: {
 *     permissions: [
 *       { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *     ]
 *   }
 * };
 * 
 * const formattedPermissions = await userHasPermissionFormated(permissionsList, permisssionsUser);
 * // Output:
 * // [
 * //   { permission_slug: 'modulo.thumano', isChecked: true, childrens: [{ slug: 'modulo.empleados', isChecked: true, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 * //   { permission_slug: 'modulo.configuracion', isChecked: false, childrens: [{ slug: 'modulo.logacciones', isChecked: false, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * // ]
 */
export const userHasPermissionFormatedUser = async ( user_permissions:any, customer_permissions:any,  ) => {


    
    const customerPermissions:any = JSON.parse(JSON.stringify(customer_permissions));
    const usersPermissions:any = JSON.parse(JSON.stringify(user_permissions));


    

    if ( customerPermissions.length > 0 && usersPermissions.length > 0  ) {

  
        // ESTA FUNCION SOLO AGREGA LA PROPIEDAD isChecked al array 
        usersPermissions.forEach( (userPermissions:any) => {

            customerPermissions.forEach( (customerPermissions:any) => {

                if (customerPermissions.permission_slug === userPermissions.permission_slug) {

                    customerPermissions.isChecked = true;

                    // COMPARAR CHILDRENS 
                    if ( userPermissions.childrens.length > 0 && customerPermissions.childrens.length > 0 ) { 
                        compareChildren(userPermissions.childrens, customerPermissions.childrens);
                    }
                }

            });

            
        });



        // COMO SE DEBE FORMATEAR OSEA PONERLE ACTIONS SI EXISTEN SIEMPRE LOS PRINCIPALES 
        // SON LOS DEL CLIENTE, PORQUE SIEMPRE SE VAN A MOSTRAR ENTONCES SE RECORRE PRIMERO 
        // LOS PERMISOS DEL CLIENTE, YA INDEPENDIENTEMENTE DE LOS DEL USUARIO PORQUE DEBE MOSTRARLOS TODOS 
        // PERO CHECKEAR LAS ACCIONES QUE COINCIDAN CON LOS PERMISOS DEL USUARIOS 
        customerPermissions.forEach( (customerPermissions:any) => {

            usersPermissions.forEach( (userPermissions:any) => {

                // COMPARAR CHILDRENS 
                if ( customerPermissions.childrens.length > 0 && userPermissions.childrens.length > 0 ) { 
                    compareChildrenActions(customerPermissions.childrens, userPermissions.childrens);
                }
            
            });

        });

        



    }

    
    return JSON.parse( JSON.stringify(customerPermissions) );
    // return customerPermissions;
       


}

function compareChildren( userChildren:any, customerChildren:any) {


    userChildren.forEach( ( userChild:any) => {
        customerChildren.forEach( ( customerChild:any) => {
            

            if (customerChild.slug === userChild.slug) {
                customerChild.isChecked = true;
                

                if ( (userChild.childrens && userChild.childrens.length > 0) && ( customerChild.childrens && customerChild.childrens.length > 0) )  {
                    compareChildren(userChild.childrens, customerChild.childrens);
                }
            }

        });
    });
    
}


function compareChildrenActions( customerChildren:any, userChildren:any ) {

    
    customerChildren.forEach( ( customerChild:any) => {

        const result = userChildren.find( (element:any) => element.slug == customerChild.slug );

        if (result) {
            customerChild.actions = result.actions;
        }


        userChildren.forEach( ( userChild:any) => {


            if ( customerChild.childrens && userChild.childrens.length > 0 ) {
                compareChildrenActions(customerChild.childrens, userChild.childrens);
                
            }

        });

        

            
            
            
        //     if (customerChild.slug === userChild.slug) {
        //         customerChild.actions = userChild.actions;
                

        //         if ( (userChild.childrens && userChild.childrens.length > 0) && ( customerChild.childrens && customerChild.childrens.length > 0) )  {
        //             compareChildrenActions(userChild.childrens, customerChild.childrens);
        //         }
        //     }

        // });

    });

    
}







export const userHasPermissionFormatedEdit = async ( user_permissions:any, customer_permissions:any  ) => {
    
    


    user_permissions.forEach( (module:any) => {

        

        if ( customer_permissions[module.permission_slug] ) {

            //  CHECKEA EL MODULO PRINCIPAN 
             ( module.isChecked) ? customer_permissions[module.permission_slug][module.permission_slug] = module.isChecked : customer_permissions[module.permission_slug][module.permission_slug] = false;
             
             
            //  VERIFICA QUE TENGA CHILDRES Y LOS RECORRE PARA CHECKEAR EL MODULO HIJO CAMBIA EL VALUE EN subModulesChecked SI EL MODULO ESTA CHECKEADO 
             if ( module.childrens && module.childrens.length > 0 ) {

                 
                module.childrens.forEach( (submodule:any) => {

                    if ( submodule.isChecked ) {
                         customer_permissions[module.permission_slug].subModulesChecked[submodule.slug] = true;
                    }
                    
               
                    // BUSCA EN LOS CHILDRESN PARA ASIGNAR LAS ACTIONS DE LOS CHILDRENS DE CADA MODULO 
                    if ( customer_permissions[module.permission_slug].childrensChecked[submodule.slug] ) {
                         
                        
                        if (submodule.actions) {
                            
                            submodule.actions.forEach( (action:any) => {
                                customer_permissions[module.permission_slug].childrensChecked[submodule.slug][action] = true;
                            });

                        }
                        
                    } 
                    



                    //  VERIFICA QUE TENGA CHILDRES Y LOS RECORRE PARA CHECKEAR EL MODULO HIJO CAMBIA EL VALUE EN subModulesChecked SI EL MODULO ESTA CHECKEADO 
                    if ( submodule.childrens && submodule.childrens.length > 0 ) {

                        submodule.childrens.forEach( (subSubmodule:any) => {
                          
                            if ( subSubmodule.isChecked ) { 
                                customer_permissions[module.permission_slug].subSubModulesChecked[subSubmodule.slug] = true;
                            }


                            // BUSCA EN LOS CHILDRESN PARA ASIGNAR LAS ACTIONS DE LOS CHILDRENS DE CADA MODULO 
                            if ( customer_permissions[module.permission_slug].subChildrensCheked[subSubmodule.slug] ) {
                                
                                
                                if (subSubmodule.actions) {
                                    
                                    subSubmodule.actions.forEach( (action:any) => {
                                        customer_permissions[module.permission_slug].subChildrensCheked[subSubmodule.slug][action] = true;
                                    });

                                }
                                
                            }
                          

                        });
                    } // END IF 

                     
                }); // END FOREACH

                
                
             } // END IF CHILDRES
             
        }


    });

    const data = JSON.parse( JSON.stringify(customer_permissions) );
    return data;
    


}





export const userHasPermissionFormatSave = async ( customer_permissions_formated:any,  modulesChecked:any, user_permissions:any   ) => {
    
    
    return JSON.parse( JSON.stringify(user_permissions) );

}


export const userHasPermission = async ( permissionItemSlug:any, permissionsList:any) => {
    

    const elementObject:any = JSON.parse(JSON.stringify(permissionsList));


    if ( permissionsList.length > 0  ) {

        
             
        const permissionExist = elementObject.map( (element:any) => {

            if ( element.permission_slug == permissionItemSlug ) {
                return true;
            }

        });


        return permissionExist;
             
        
         
    }

    return false;


}





export const userHasSubmodulePermission = async ( permissionItemSlugParent:any, permissionItemSlugChildern:any, permissions:any) => {
    

    // const elementObject:any = JSON.parse(JSON.stringify(permissionsList));


    if ( permissions.length > 0  ) {

        // console.log('chupepeppeper hasPermissions ', hasPermissions)
        
              
        for (let index = 0; index < permissions.length; index++) {
        
            if ( permissions[index].permission_slug == permissionItemSlugParent ) { 
                
                 for (let i = 0; i < permissions[index].childrens.length; i++) {
                    
                    

                     if ( permissions[index].childrens[i].slug == permissionItemSlugChildern ) {
                       
                        //   if ( permissions[index].childrens[i].actions.includes(action) ) {
                        //        return true;
                        //   }
                        return true;
   
                     }
                   
                 }
            }

            
           
       }
   
       return false;
             
        
         
    }

    return false;


}




export const closeSessionGlobal = async () => {

        await AsyncStorage.removeItem(types.storage.userStorage);
        await AsyncStorage.removeItem(types.storage.permissionsStorage);
        await AsyncStorage.removeItem(types.storage.userPermissionsStorage);

}



export const calcularDiferenciaHoras = ( horaInicio:string, horaFin:string ) => {
    
    const [hInicio, mInicio] = horaInicio.split(":").map(Number);
    const [hFin, mFin] = horaFin.split(":").map(Number);

    // Convertir ambas horas a minutos totales
    const minutosInicio = hInicio * 60 + mInicio;
    const minutosFin = hFin * 60 + mFin;

    // Calcular diferencia en minutos
    let diferenciaMinutos = minutosFin - minutosInicio;

    // Si la diferencia es negativa, cruzó medianoche
    if (diferenciaMinutos < 0) {
        diferenciaMinutos += 24 * 60;
    }

    const horas = Math.floor(diferenciaMinutos / 60);
    const minutos = diferenciaMinutos % 60;

    return { horas, minutos };
}


export const formatDateToYmd = (dateParameter: Date) => {

    if ( !dateParameter || dateParameter == undefined ) {
        return 'N/A';
    }
    
    const date = new Date(dateParameter);

    // Opciones de formato
    const options:any = { day: 'numeric', month: 'long', year: 'numeric' };

    // Convertir a formato deseado
    return date.toLocaleDateString('es-CO', options);

}



export const formatDateToYmdNumeric = (dateParameter: Date) => {

    if ( !dateParameter || dateParameter == undefined ) {
        return 'N/A';
    }
    
    const date = new Date(dateParameter);

    const dia = date.getDate().toString().padStart(2, '0'); // Día con 2 dígitos
    const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // Mes con 2 dígitos
    const anio = date.getFullYear(); // Año con 4 dígitos

    return `${dia}/${mes}/${anio}`;

}




export const firstLetterUpperCase = (texto:string) => {

    // Verifica si el texto no está vacío
    if (!texto) return texto;

  
    // Convierte la primera letra a mayúscula y concatena el resto del texto
    return texto.charAt(0).toUpperCase() + texto.slice(1);
}


// RECORRE LOS PERMISOS PARA VER SI EL PATH DE LA URL QUE SE RECIBE POR PARAMETRO CONINCIDE Y SE DEVUELVE ESE INDEX 
// PARA QUE ABRA EL MENU PARENT, SI NO LO ENCUENTRA ENTRA EN EL ELSE PARA SABER SI ES UN SUB ARRAY DEL ARRAY  Y DEVUELVA 
// EL INDEX DEL PADRE Y DEL SUB MENU 
export const getIndexParentMenu = async( parentSlug:string ) => {

    const permissions =  await storageGetAssignedUserPermissions();

    for (let index = 0; index < permissions.length; index++) { 
            
            for (let i = 0; i < permissions[index].childrens.length; i++) {
                
                if ( permissions[index].childrens[i].to == parentSlug ) { 
                    return index;
                }
            }
    }
    return 700;

}

